import { CreateCsvInfo } from '@/coreDomainsModule/exportFileManage';
import { INetworkResult } from '@/coreDomainsModule/networkResult';
import { CreateCsvUseCase } from './createCsvUseCase';

/**
 * シミュレーション結果をCSVで出力する
 */
export class CreateChartDataForCsvUseCase {
  /**
   * Execute
   * @param simulateResult - 現在スタックされているデータ
   */
  public Execute = async (simulateResult: CreateCsvInfo): Promise<INetworkResult<void, Error>> => {
    const createCsvUseCase = new CreateCsvUseCase();
    const res = await createCsvUseCase.Execute(simulateResult.data, simulateResult.title);
    switch (res.status.type) {
      case 'success':
        break;
      case 'error':
        return {
          status: {
            type: 'error',
            error: res.status.error,
          },
        };
    }
    return {
      status: {
        type: 'success',
        data: undefined,
      },
    };
  };
}
